module.exports = __webpack_public_path__ + "img/03_L3.543ad206.svg";